import './index.less';

import { Button } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

interface IProps {
  closeActiveMenu: () => void;
  goToPreviewFlow: () => void;
}

export default function PlatformMenu({ closeActiveMenu, goToPreviewFlow }: IProps) {
  return (
    <div className="nav-platform-menu" onClick={closeActiveMenu}>
      <div className="nav-platform-menu-banner-wrap">
        <Image
          src={'https://static.pietrastudio.com/public/file_uploads/488589db780415a711777f04dffa7d8b.png'}
          alt="pietra"
          width={110}
          height={64}
        />
        <div className="banner-content">
          <div className="title">Pietra e-commerce suite</div>
          <div className="description">
            One monthly fee gets you access to all the best software & services you need to run an e-commerce brand.
          </div>
        </div>
        <Button onClick={goToPreviewFlow}>Talk to sales</Button>
      </div>
      <div className="menu-content">
        <div className="menu-content-item-container">
          <h4>By role</h4>
          <ul>
            <li>
              <Link href={'/new-brands'} className="link">
                E-commerce founders
              </Link>
            </li>
            <li>
              <Link href={'/role/marketing-teams'} className="link">
                Marketing teams
              </Link>
            </li>
            <li>
              <Link href={'/role/operations-teams'} className="link">
                Operations teams
              </Link>
            </li>
          </ul>
        </div>
        <div className="menu-content-item-container case">
          <h4>By use case</h4>
          <ul>
            <li>
              <Link href={'/use-case/new-business'} className="link">
                Start a new business
              </Link>
            </li>
            <li>
              <Link href={'/platform/social-analysis'} className="link">
                Monitor your competitors
              </Link>
            </li>
            <li>
              <Link href={'/use-case/lower-costs'} className="link">
                Launch a new product line
              </Link>
            </li>
            <li>
              <Link href={'/platform/affiliate-marketing'} className="link">
                Hire influencers for your brand
              </Link>
            </li>
            <li>
              <Link href={'/platform/logistics-and-fulfillment'} className="link">
                Lower fulfillment costs
              </Link>
            </li>
            <li>
              <Link href={'/use-case/sell-merch'} className="link">
                Create & sell branded merch
              </Link>
            </li>
            <li>
              <Link href={'/use-case/grow-sales'} className="link">
                Grow sales
              </Link>
            </li>
            <li>
              <Link href={'/use-case/pr-boxes'} className="link">
                Make & ship PR boxes
              </Link>
            </li>
            <li>
              <Link href={'/sourcing?tab=Products'} className="link">
                Discover new factories
              </Link>
            </li>
            <li>
              <Link href={'/use-case/retail-expansion'} className="link">
                Expand into retail
              </Link>
            </li>
            <li>
              <Link href={'/platform/sourcing-and-production/products'} className="link">
                Manage existing suppliers
              </Link>
            </li>
            <li>
              <Link href={'/platform/content-studio'} className="link">
                Create marketing content
              </Link>
            </li>
            <li>
              <Link href={'/platform/sourcing-and-production/products'} className="link">
                Hire QC services
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
